import { style } from '@vanilla-extract/css'

const brands = style({
  maxWidth: '230px',
})

const heading = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
})

const maskedNumber = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: '#828282',
})

const payjpInputContainer = style({
  width: '100%',
  padding: '0 12px',
  boxSizing: 'border-box',
  backgroundColor: 'white',
  outlineWidth: '1px',
  borderRadius: '8px',
  border: '0.5px solid #00000014',
})

const payjpInput = style({
  color: '#252525',
  caretColor: '#252525',
  backgroundColor: 'white',
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '44px',
  letterSpacing: '0.02em',
  width: '100%',
  height: '44px',
  border: 'none',
  padding: '0px',
  margin: '0px',
  inset: '0px',
  outline: 'none 0px',
  selectors: {
    '&::placeholder': {
      color: 'rgba(130, 130, 130, 0.6)',
    },
    '&:focus': {
      outline: 'none 0px',
    },
    '&:focus-visible': {
      outline: 'none 0px',
      boxShadow: 'none',
    },
  },
})

const label = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontWeight: '700',
  fontSize: '13px',
  color: '#828282',
})

export const styles = {
  brands,
  heading,
  maskedNumber,
  payjpInputContainer,
  payjpInput,
  label,
}
